import React, { useEffect, useMemo, useState } from "react";
import '../styles/Goal.css'
import '../styles/CommonGoal.css';
import StudentCard, { StudentCardProps } from "./CommonStudentCard";
import people from "../images/user-icon2.svg";
import noStudent from "../images/no-student.svg";
import Deadline from "../deadline";
import moreIcon from "../images/more-icon.svg";
import { useFetch } from "../hooks/useFetch";
import CardSkeleton from "./CommonCardSkeleton";
import { useCookies } from "react-cookie";
import Button from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { ThemeProvider, createTheme } from "@material-ui/core";

interface CommonGoalProps {
    id: number;
    no: number;
    goal: string;
    description: string;
    deadline: string;
    openDialog: boolean;
    setOpenDialog: any;
    openGoalDetail: boolean;
    setOpenGoalDetail: any;
    openEditDueDate: boolean;
    setOpenEditDueDate: any;
    handleGoalIdTarget: any;
    sortKey: string;
    search: string;
    semesterId: number;
    courseId: number;
    setNumberOfStudentInCommonGoal?: any;
}
export interface CommonGoalType {
    id: number,
    no: number,
    goal: string,
    description: string,
    deadline: string,
}

export default function CommonGoal({ id, no, goal, description, deadline, openDialog, setOpenDialog, openEditDueDate, setOpenEditDueDate, handleGoalIdTarget, openGoalDetail, setOpenGoalDetail, sortKey, search, semesterId, courseId, setNumberOfStudentInCommonGoal }: CommonGoalProps) {

    const deadlineDate = new Deadline(new Date(deadline))

    const deadlineStyles = {
        color: deadlineDate.deadlineColor,
    }

    const [studentList, setStudentList] = useState([])
    const [graduateStudentList, setGraduateStudentList] = useState([])
    const [dropoutStudentList, setDropoutStudentList] = useState([])

    const [studentListCopy, setStudentListCopy] = useState([])
    const [graduateStudentListCopy, setGraduateStudentListCopy] = useState([])
    const [dropoutStudentListCopy, setDropoutStudentListCopy] = useState([])

    const [cookies, setCookie] = useCookies(['user'])

    const { data: getStudentsData, status: getStudentsStatus, error: getStudentsError, loading: getStudentsLoading } = useFetch({
        url: `/Students/goal?commonGoalId=${id}`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    }, openDialog)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null);
    }

    const moreMenuTheme = createTheme({
        typography: {
            fontSize: 12,
        },
    })

    useEffect(() => {
        if (getStudentsData) {
            splitStudentList()
            searchStudentList(search)
            sortStudentList(sortKey)
        } else {
            setStudentList([])
            setGraduateStudentList([])
            setDropoutStudentList([])
        }
    }, [getStudentsData])

    function splitStudentList() {
        if (getStudentsData) {
            const DROPOUT_STATUS = 5
            const GRADUATE_STATUS = 2

            const dropout = getStudentsData.filter((student: StudentCardProps) => student.studentStatusId === DROPOUT_STATUS)
            const grad = getStudentsData.filter((student: StudentCardProps) => student.studentStatusId === GRADUATE_STATUS)
            const normal = getStudentsData.filter((student: StudentCardProps) => student.studentStatusId !== DROPOUT_STATUS && student.studentStatusId !== GRADUATE_STATUS)

            setDropoutStudentList(dropout)
            setGraduateStudentList(grad)
            setStudentList(normal)

            setDropoutStudentListCopy(dropout)
            setGraduateStudentListCopy(grad)
            setStudentListCopy(normal)
        }
    }

    useMemo(() => splitStudentList(), [getStudentsData])

    function sortStudentList(key: string) {
        if (key === 'name') {
            setStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
            setGraduateStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
            setDropoutStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    const nameA = a.firstName + ' ' + a.lastName
                    const nameB = b.firstName + ' ' + b.lastName
                    return nameA.localeCompare(nameB)
                })
            })
        } else if (key === 'studentId') {
            setStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            setGraduateStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            setDropoutStudentList(prev => {
                return [...prev].sort((a: StudentCardProps, b: StudentCardProps) => {
                    return (a.id).localeCompare(b.id)
                })
            })
        }
    }

    useMemo(() => sortStudentList(sortKey), [sortKey])

    // NOT COMPLETE
    function searchStudentList(search: string) {
        if (getStudentsData) {
            if (search === '') {
                splitStudentList()
            } else {
                setStudentList(studentListCopy.filter((student: StudentCardProps) => {
                    const name = student.title + ' ' + student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))
                setGraduateStudentList(graduateStudentListCopy.filter((student: StudentCardProps) => {
                    const name = student.title + ' ' + student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))
                setDropoutStudentList(dropoutStudentListCopy.filter((student: StudentCardProps) => {
                    const name = student.title + ' ' + student.firstName + ' ' + student.lastName
                    return name.toLowerCase().includes(search.toLowerCase()) || student.id.toLowerCase().includes(search.toLowerCase())
                }))
                updateNumberOfStudentInCommonGoal()
            }
        }
    }

    useMemo(() => searchStudentList(search), [search])

    // COUNT NUMBER OF STUDENT IN COMMON GOAL
    function updateNumberOfStudentInCommonGoal() {
        if (!setNumberOfStudentInCommonGoal) return
        setNumberOfStudentInCommonGoal((prev: { [key: number]: number }) => {
            return { ...prev, [id]: studentList.length + graduateStudentList.length + dropoutStudentList.length }
        })
    }

    useEffect(() => updateNumberOfStudentInCommonGoal(), [studentList, graduateStudentList, dropoutStudentList])

    const handleOpenGoalDetail = () => {
        handleGoalIdTarget(id)
        setOpenGoalDetail(true)
    }

    const handleOpenEditDueDate = () => {
        handleGoalIdTarget(id)
        setOpenEditDueDate(true)
        setAnchorEl(null)
    }

    return (
        <div className="Goal-goal">
            <header>
                <div className="Goal-title">
                    <button className="elicpse" onClick={handleOpenGoalDetail}>
                        <h4 className="elicpse" title={goal}>{goal}</h4>
                    </button>
                    {(search === '') && <>
                        <div className="Goal-amount">
                            <img src={people} alt="People Icon" />
                            <h5>{studentList.length + graduateStudentList.length + dropoutStudentList.length}</h5>
                        </div>
                        <div className="Goal-more-btn">
                            <ThemeProvider theme={moreMenuTheme}>
                                <Button
                                    aria-label="more"
                                    aria-controls={open ? 'long-menu' : undefined}
                                    aria-expanded={open ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleClick}
                                    style={{ padding: "0.125rem" }}
                                >
                                    <img src={moreIcon} alt="" />
                                </Button>
                                <Menu
                                    id="long-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={open}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    style={{ marginTop: "2.25rem", marginLeft: "2rem" }}
                                >
                                    <MenuItem onClick={handleOpenEditDueDate}>Edit Due Date</MenuItem>
                                </Menu>
                            </ThemeProvider>
                        </div>
                    </>}
                </div>
                <div className="Goal-deadline" style={deadlineStyles}>
                    <h6 className="Goal-date">{deadlineDate.deadline}</h6>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <img className="Goal-deadline-icon" src={deadlineDate.srcIcon} alt="" />
                        <h6 className="Goal-countdown">{deadlineDate.diffDaysText}</h6>
                    </div>
                </div>
            </header>
            {
                (getStudentsData === null) &&
                <div className="Goal-list">
                    <CardSkeleton />
                    <CardSkeleton />
                    <CardSkeleton />
                    <CardSkeleton />
                </div>
            }
            {(getStudentsData !== null && (studentList.length !== 0 || graduateStudentList.length !== 0 || dropoutStudentList.length !== 0)) &&
                <div className="Goal-list">
                    {studentList.map(({ id, title, firstName, lastName, commonProgressId, studentStatus, studentStatusId }: StudentCardProps) => (
                        <StudentCard
                            key={commonProgressId}
                            commonProgressId={commonProgressId}
                            title={title}
                            firstName={firstName}
                            lastName={lastName}
                            id={id}
                            studentStatus={studentStatus}
                            studentStatusId={studentStatusId}
                            onClick={() => setOpenDialog(true)}
                            semesterId={semesterId}
                            courseId={courseId}
                        />
                    ))}
                    {graduateStudentList.map(({ id, title, firstName, lastName, commonProgressId, studentStatus, studentStatusId }: StudentCardProps) => (
                        <StudentCard
                            key={commonProgressId}
                            commonProgressId={commonProgressId}
                            title={title}
                            firstName={firstName}
                            lastName={lastName}
                            id={id}
                            studentStatus={studentStatus}
                            studentStatusId={studentStatusId}
                            onClick={() => setOpenDialog(true)}
                            semesterId={semesterId}
                            courseId={courseId}
                        />
                    ))}
                    {dropoutStudentList.map(({ id, title, firstName, lastName, commonProgressId, studentStatus, studentStatusId }: StudentCardProps) => (
                        <StudentCard
                            key={commonProgressId}
                            commonProgressId={commonProgressId}
                            title={title}
                            firstName={firstName}
                            lastName={lastName}
                            id={id}
                            studentStatus={studentStatus}
                            studentStatusId={studentStatusId}
                            onClick={() => setOpenDialog(true)}
                            semesterId={semesterId}
                            courseId={courseId}
                        />
                    ))}
                </div>}
            {(getStudentsData !== null && studentList.length === 0 && graduateStudentList.length === 0 && dropoutStudentList.length === 0) &&
                <div className="Goal-no-student">
                    <img src={noStudent} alt="No Student" />
                </div>
            }
        </div>
    )
}